<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import BaseButtonBulk from './BaseButtonBulk.vue'

@Component({
  name: 'ResetButtonBulk',
})
export default class ResetButtonBulk extends BaseButtonBulk {
  protected color = 'is-info'
}
</script>
